import PropTypes from "prop-types";
import React from 'react';
import accounting from 'accounting';
import TermDefs from 'term_defs';
import { PlanDetails } from './shopBagItemStyles';

const SubscriptionDetails = ({ productBilling, price, numCycles, currencySymbol, quantity = 0 }) => {
	if (!productBilling) {
		// No product billing means this is an ecom product and we won't have terms
		// so we have to render a simpler breakdown
		const pricePerItem = accounting.formatMoney(price / 100, currencySymbol);
		return (
			<PlanDetails>
				Qty: {quantity} {quantity > 1 ? `(${pricePerItem} each)` : ""}
			</PlanDetails>
		);
	}

	const { rebillMonths, rebillWeeks } = productBilling;
	const perCycleCost = accounting.formatMoney(price / numCycles / 100, currencySymbol);
	const { cardTop, cycleAbbr, autoRenews } = TermDefs.getTermBlob(rebillMonths, rebillWeeks, numCycles) || {};
	const rebillCycle = rebillWeeks || rebillMonths;
	let deliveryCycle = rebillWeeks > 0 ? 'week' : 'month';
	if (rebillCycle > 1) {
		deliveryCycle = `${rebillCycle} ${deliveryCycle}s`;
	}

	return (
		<PlanDetails>
			{cardTop} @ {perCycleCost} / {cycleAbbr}
			<br />
			{autoRenews && "Auto-renews"}
		</PlanDetails>
	);
};

SubscriptionDetails.propTypes = {
	currencySymbol: PropTypes.string.isRequired,
	numCycles: PropTypes.number,
	price: PropTypes.number.isRequired,
	productBilling: PropTypes.shape({
		rebillMonths: PropTypes.number,
		rebillWeeks: PropTypes.number
	}),
	quantity: PropTypes.number,
	termName: PropTypes.string,
};

export default SubscriptionDetails;